import React, { PureComponent } from 'react';
import { View, ListView } from 'react-native';
import RecentSearchRow from './recent-search-row';
import styles from './recent.search.styles';
import { H2 } from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';

class RecentSearch extends PureComponent {
  constructor(props) {
    super(props);
    const ds = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2,
    });
    this.state = {
      dataSource: ds.cloneWithRows(this.props.data),
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: this.state.dataSource.cloneWithRows(nextProps.data),
    });
  }
  render() {
    const { i18n: { messages } } = this.props;
    let screenHeight = this.props.screen.height - 400 + 'px';

    return (
      <div className="search-grid">
        <H2 secondary className="recent-search-title">
          {messages['app.Search.recentSearchTitle']}
        </H2>
        <div style={{ minHeight: screenHeight, marginTop: '16px' }}>
          <ListView
            dataSource={this.state.dataSource}
            renderRow={(data, sectionId, index) => (
              <RecentSearchRow selectedRow={this.props.selectedRow} index={index} {...data} />
            )}
          />
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true,
    },
    i18n: {
      messages: true,
    },
  },
})(RecentSearch);
